import Tooltip from './TooltipBase';

export default Tooltip;
